import { useTheme } from '@vitvio/design-system';
import { FaBug } from 'react-icons/fa';
import { MISSION_CONTROL_ONLY_FLAG } from '@vitvio/feature-flags';

import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { useConnectionStatus } from '@vitvio/connection-provider';
import { IconContext } from 'react-icons';

export function SidebarDebugIcon() {
  const { getFlag } = useKindeAuth();
  const { isConnected } = useConnectionStatus();

  const missionControlOnly = getFlag && getFlag(MISSION_CONTROL_ONLY_FLAG, false, 'b').value;

  const { getColor } = useTheme();

  if (missionControlOnly) {
    return null;
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IconContext.Provider
        value={{
          style: {
            color: getColor(isConnected ? 'fg' : 'fg.error'),
          },
        }}
      >
        <FaBug />
      </IconContext.Provider>
    </div>
  );
}
